/**
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Routes } from '@angular/router';
import { TermsComponent } from './terms/terms.component';
import { MainComponent } from './main/main.component';
export const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'project',
    children: [
      {
        path: ':project/dataset/:dataset/table/:table',
        component: MainComponent
      },
      {
        path: ':project/job',
        children: [
          {
            path: ':job/location/:location',
            component: MainComponent
          },
          {
            path: ':job',
            component: MainComponent
          },
        ]
      },
    ]
  },
];
